import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// Airtable constants
import { IMGBB_API_KEY, AIRTABLE_URL_TECHNICIAN, AIRTABLE_HEADERS } from "./constants";

// ✅ SINGLE export default function
export default function TechnicianDetails() {
  const [technician, setTechnician] = useState({
    name: "",
    dateofbirth: "",
    address: "",
    pincode: "",
    phone: "",
    pan: "",
    aadhaar: "",
    bankName: "",
    accountNumber: "",
    ifsc: "",
    passportSizePhoto: null,
    aadhaarPhoto: null,
    aadhaarBackPhoto: null,
    panPhoto: null,
    password: ""
  });

  const [errors, setErrors] = useState({});
  const [showAgreement, setShowAgreement] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const navigate = useNavigate();

  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case "name":
        if (!/^[A-Za-z\s]+$/.test(value)) error = "Name must contain only alphabets";
        break;
      case "dateofbirth":
        if (!/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-(19|20)\d\d$/.test(value)) {
          error = "Date must be in dd-mm-yyyy format";
        }
        break;
      case "phone":
        if (!/^[0-9]{10}$/.test(value)) error = "Phone must be 10 digits";
        break;
      case "pan":
        if (!/^[A-Z0-9]{10}$/.test(value)) error = "PAN must be 10 characters and in UPPARCASE";
        break;
      case "aadhaar":
        if (!/^[0-9]{12}$/.test(value)) error = "Aadhaar must be 12 digits";
        break;
      default:
        break;
    }
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const hasErrors = Object.values(errors).some((err) => err);
 const uploadImageToImgbb = async (file) => {
  const formData = new FormData();
  formData.append("image", file);

  const res = await fetch(
    `https://api.imgbb.com/1/upload?key=${IMGBB_API_KEY}`,
    {
      method: "POST",
      body: formData,
    }
  );

  const data = await res.json();
  return data.data.url;
};


  const handleSubmit = async () => {
  const fieldsToValidate = ["name", "dateofbirth", "phone", "pan", "aadhaar"];
  const newErrors = {};

  // Validate required fields
  fieldsToValidate.forEach((field) => {
    const value = technician[field];
    let error = "";
    switch (field) {
      case "name":
        if (!value || !/^[A-Za-z\s]+$/.test(value)) {
          error = "Name must contain only alphabets";
        }
        break;
      case "dateofbirth":
        if (!value || !/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-(19|20)\d\d$/.test(value)) {
          error = "Date must be in dd-mm-yyyy format";
        }
        break;
      case "phone":
        if (!value || !/^[0-9]{10}$/.test(value)) {
          error = "Phone must be 10 digits";
        }
        break;
        case "pincode":
        if (!value || !/^[0-9]{6}$/.test(value)) {
          error = "pincode must be 6 digits";
        }
        break;
      case "pan":
        if (!value || !/^[A-Z0-9]{10}$/.test(value)) {
          error = "PAN must be 10 characters";
        }
        break;
      case "aadhaar":
        if (!value || !/^[0-9]{12}$/.test(value)) {
          error = "Aadhaar must be 12 digits";
        }
        break;
      default:
        break;
    }
    if (error) {
      newErrors[field] = error;
    }
  });

  setErrors(newErrors);

  if (Object.keys(newErrors).length > 0) {
    // Show the first error in an alert (or you could list all if preferred)
    const firstErrorField = Object.keys(newErrors)[0];
    alert(`Error in "${firstErrorField}": ${newErrors[firstErrorField]}`);
    return;
  }

  if (
  !technician.passportSizePhoto ||
  !technician.aadhaarPhoto ||
  !technician.aadhaarBackPhoto || // ✅ Added
  !technician.panPhoto
) {
  return alert("Please upload all required photos: Passport size photo, Aadhaar Front, Aadhaar Back, and PAN.");
}


  if (!agreed) {
    return alert("Please agree to the rules before submitting.");
  }

  try {
    const passportSizePhotoUrl = await uploadImageToImgbb(technician.passportSizePhoto);
    const aadhaarPhotoUrl = await uploadImageToImgbb(technician.aadhaarPhoto);
    const aadhaarBackPhotoUrl = await uploadImageToImgbb(technician.aadhaarBackPhoto);
    const panPhotoUrl = await uploadImageToImgbb(technician.panPhoto);

    const fullTechnicianData = {
      name: technician.name,
      dateofbirth: technician.dateofbirth,
      address: technician.address,
      pincode: technician.pincode,
      phone: technician.phone,
      pan: technician.pan,
      aadhaar: technician.aadhaar,
      bankName: technician.bankName,
      accountNumber: technician.accountNumber,
      ifsc: technician.ifsc,
      passportSizePhoto: passportSizePhotoUrl,
      aadhaarPhoto: aadhaarPhotoUrl,
      aadhaarBackPhoto: aadhaarBackPhotoUrl,
      panPhoto: panPhotoUrl,
      password: technician.password,
      status: "pending",
      timestamp: new Date().toLocaleString()
    };
const response = await fetch(AIRTABLE_URL_TECHNICIAN, {
  method: "POST",
  headers: AIRTABLE_HEADERS, // ✅ centralized headers
  body: JSON.stringify({
    records: [{ fields: fullTechnicianData }]
  })
});

   const result = await response.json();

if (!response.ok) {
  console.error("🛑 Airtable Error:", result);

  // Airtable gives detailed error like:
  // { "error": { "message": "...", "type": "...", "details": { "field": "pan" } } }
  const airtableError = result?.error?.message || "Unknown error from Airtable";
  const failedField = result?.error?.details?.field;

  alert(`❌ Submission failed.\n${airtableError}${failedField ? `\nField: ${failedField}` : ""}`);
  return;
}

localStorage.setItem("technicianPhone", technician.phone);
alert("Technician details submitted successfully!");
navigate("/technician-dashboard");

 } catch (error) {
  console.error("💥 Upload error:", error);

  // 🧪 Extra debug info for missing/invalid fields
  Object.entries(technician).forEach(([key, value]) => {
    if (!value) {
      console.warn(`⚠️ Missing or invalid value: ${key} =`, value);
    }
  });

  alert("Something went wrong! Check console for missing/invalid fields.");
}

};


  return (
    <div style={{ padding: "40px 15px", fontFamily: "Arial, sans-serif", textAlign: "left", maxWidth: "100%" }}>
      <h2 style={{ marginBottom: 20 }}>Technician Details</h2>

      <input
        placeholder="Full Name (as on PAN card)"
        value={technician.name}
        onChange={(e) => {
          setTechnician({ ...technician, name: e.target.value });
          validateField("name", e.target.value);
        }}
        onBlur={(e) => validateField("name", e.target.value)}
        style={inputStyle}
      />
      {errors.name && <div style={{ color: "red", fontSize: 12 }}>{errors.name}</div>}

      <input
        placeholder="Date of Birth (as on PAN card dd-mm-yyyy)"
        value={technician.dateofbirth}
        onChange={(e) => {
          setTechnician({ ...technician, dateofbirth: e.target.value });
          validateField("dateofbirth", e.target.value);
        }}
        onBlur={(e) => validateField("dateofbirth", e.target.value)}
        style={inputStyle}
      />
      {errors.dateofbirth && <div style={{ color: "red", fontSize: 12 }}>{errors.dateofbirth}</div>}

      <input placeholder="Full Address" value={technician.address}
        onChange={(e) => setTechnician({ ...technician, address: e.target.value })} style={inputStyle} />

        <input
  type="tel"
  inputMode="numeric"
  maxLength={6}
  placeholder="Pincode"
  value={technician.pincode}
  onChange={(e) =>
    setTechnician({ ...technician, pincode: e.target.value.replace(/\D/g, "") })
  }
  style={inputStyle}
/>

<input
  type="tel"
  inputMode="numeric"
  maxLength={10}
  placeholder="Phone Number"
  value={technician.phone}
  onChange={(e) => {
    const onlyDigits = e.target.value.replace(/\D/g, "");
    setTechnician({ ...technician, phone: onlyDigits });
    validateField("phone", onlyDigits);
  }}
  onBlur={(e) => validateField("phone", e.target.value)}
  style={inputStyle}
/>

{errors.phone && (
  <div style={{ color: "red", fontSize: 12 }}>{errors.phone}</div>
)}

      <input
        placeholder="PAN Card Number"
        value={technician.pan}
        onChange={(e) => {
          setTechnician({ ...technician, pan: e.target.value });
          validateField("pan", e.target.value);
        }}
        onBlur={(e) => validateField("pan", e.target.value)}
        style={inputStyle}
      />
      {errors.pan && <div style={{ color: "red", fontSize: 12 }}>{errors.pan}</div>}

     <input
  type="tel"
  inputMode="numeric"
  maxLength={12}
  placeholder="Aadhaar Number"
  value={technician.aadhaar}
  onChange={(e) => {
    const onlyDigits = e.target.value.replace(/\D/g, "");
    setTechnician({ ...technician, aadhaar: onlyDigits });
    validateField("aadhaar", onlyDigits);
  }}
  onBlur={(e) => validateField("aadhaar", e.target.value)}
  style={inputStyle}
/>

{errors.aadhaar && (
  <div style={{ color: "red", fontSize: 12 }}>{errors.aadhaar}</div>
)}

      <input placeholder="Bank Name" value={technician.bankName}
        onChange={(e) => setTechnician({ ...technician, bankName: e.target.value })} style={inputStyle} />
      <input
  type="tel"
  inputMode="numeric"
  pattern="[0-9]*"
  placeholder="Bank Account Number"
  value={technician.accountNumber}
  onChange={(e) =>
    setTechnician({ ...technician, accountNumber: e.target.value })
  }
  style={inputStyle}
/>

      <input placeholder="IFSC Code" value={technician.ifsc}
        onChange={(e) => setTechnician({ ...technician, ifsc: e.target.value })} style={inputStyle} />

      <label>Upload Passport Size Photo:</label>
      <input type="file" accept="image/*"
        onChange={(e) => setTechnician({ ...technician, passportSizePhoto: e.target.files[0] })} style={inputStyle} />
      <label>Upload Aadhaar Photo:</label>
      <input type="file" accept="image/*"
        onChange={(e) => setTechnician({ ...technician, aadhaarPhoto: e.target.files[0] })} style={inputStyle} />
      <label>Upload Aadhaar Back Photo:</label> 
      <input type="file" accept="image/*"
       onChange={(e) => setTechnician({ ...technician, aadhaarBackPhoto: e.target.files[0] })} style={inputStyle}/>
      <label>Upload PAN Card Photo:</label>
      <input type="file" accept="image/*"
        onChange={(e) => setTechnician({ ...technician, panPhoto: e.target.files[0] })} style={inputStyle} />
      <input placeholder="Password" value={technician.password}
        onChange={(e) => setTechnician({ ...technician, password: e.target.value })} style={inputStyle} />

      <button
        type="button"
        onClick={() => setShowAgreement(!showAgreement)}
        style={{
          backgroundColor: "#f1f1f1",
          color: "#333",
          border: "1px solid #ccc",
          padding: "10px",
          width: "100%",
          marginTop: 20,
          cursor: "pointer"
        }}
      >
        {showAgreement ? "Hide Agreement Rules ▲" : "Show Agreement Rules ▼"}
      </button>

      {showAgreement && (
        <div
          style={{
            backgroundColor: "#f9f9f9",
            border: "1px solid #ddd",
            borderRadius: 6,
            padding: 15,
            marginTop: 10,
            fontSize: 14,
            width: "100%",
            maxWidth: "100%",
            margin: 0,
            boxSizing: "border-box",
          }}
        >
          <ul style={{ paddingLeft: 16, margin: 0 }}>
            <li>Only candidates aged 24 or above are eligible to apply</li>
            <li>Technicians must carry valid ID proof.</li>
            <li>Clean uniform and ID mandatory.</li>
            <li>No misbehavior or overcharging.</li>
            <li>Misbehavior with customers may lead to account suspension.</li>
            <li>Company reserves the right to review and remove technicians.</li>
            <li>Use only verified parts.</li>
            <li>Respect customer privacy.</li>
            <li>Be punctual for assigned services.</li>
            <li>All payments will be made weekly to your bank account.</li>
            <li>You may reject up to two assigned services if you're not comfortable with them.</li>
          </ul>

          <label style={{ display: "block", marginTop: 10 }}>
            <input
              type="checkbox"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              style={{ marginRight: 8 }}
            />
            I agree to the above Agreement Rules
          </label>
        </div>
      )}

      <button
        onClick={handleSubmit}
        disabled={!agreed || hasErrors}
        style={{
          backgroundColor: agreed && !hasErrors ? "blue" : "gray",
          color: "white",
          padding: 10,
          width: "100%",
          borderRadius: 6,
          marginTop: 20,
          cursor: agreed && !hasErrors ? "pointer" : "not-allowed"
        }}
      >
        Submit
      </button>

      <button
        onClick={() => navigate("/technician-login")}
        style={{
          position: "absolute",
          top: 10,
          right: 10,
          background: "none",
          border: "none",
          fontSize: 20,
          cursor: "pointer",
          color: "Black"
        }}
      >
        ✖
      </button>
    </div>
  );
}

const inputStyle = {
  width: "100%", marginBottom: 10, padding: 8
};
